import { saveTeamsDirectorActions } from "./action";

const initialState = {
  teamsDetailsDirect: {},
  partnerPersonID: "",
};

const directDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case saveTeamsDirectorActions.SAVE_TEAMS_DIRECTOR_DETAILS_SUCCESS:
      return {
        ...state,
        teamsDetailsDirect: action.payload.data,
        partnerPersonID: action.payload.data?.PARTNER_TEAM_PERSON_ID,
      };
    case saveTeamsDirectorActions.SAVE_TEAMS_DIRECTOR_DETAILS_ERROR:
      return {
        ...state,
        teamsDetailsDirect: [],
        partnerPersonID: "",
      };

    default:
      return state;
  }
};

export default directDetailsReducer;
